// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0cc0dbae","44":"1515b142","488":"ef71ec03","519":"7d0ce86d","740":"6b26a9fd"}[chunkId] + ".chunk.js";
};